/**
 * Le o 409 `active_provision_job:<id>_status=<status>` e diz o que o operador
 * pode fazer a respeito.
 *
 * Motivador (09/09/2026): o app 4300 devolveu quatro 409 seguidos no
 * `access-mode`, todos `active_provision_job:115_status=needs_validation`. O
 * erro NOMEAVA o job e a tela nao oferecia nada — o `POST /jobs/115/validate`
 * existe e so foi alcancado chamando o endpoint fora da interface.
 *
 * `needs_validation` e o unico status acionavel aqui: e terminal, e so um
 * humano o move. Nos demais ha trabalho em voo e nao ha o que validar — a tela
 * informa e pronto.
 */
export type JobBloqueando = { id: number; status: string; acionavel: boolean }

const PADRAO = /active_provision_job:(\d+)_status=([a-z_]+)/

export function lerJobBloqueando(err: unknown): JobBloqueando | null {
  const e = err as { response?: { data?: { detail?: unknown } } } | null | undefined
  const detail = e?.response?.data?.detail
  const texto =
    typeof detail === 'string'
      ? detail
      : typeof (detail as { message?: unknown })?.message === 'string'
        ? ((detail as { message: string }).message)
        : ''
  const m = PADRAO.exec(texto)
  if (!m) return null
  return {
    id: Number(m[1]),
    status: m[2],
    acionavel: m[2] === 'needs_validation',
  }
}
